<template>
  <pt-login class="pt-login__page"></pt-login>
</template>

<script>
import PtLogin from 'cps/pt-login/withData'
export default {
  name: 'pt-login__view',
  components: {
    'pt-login': PtLogin
  }
}
</script>
